import { Section } from '@/src/containers/Landings/Section';
import { Typography } from '@/src/shared/components/Typography';

import styles from './DifferentIndustry.module.scss';
import { IndustriesData } from './constants';
import IndustryItem from './IndustryItem';
import { useIsMobile } from '@/src/shared/hooks/utils/useIsMobile';

export const DifferentIndustry = () => {
  const isMobile = useIsMobile();

  return (
    <Section className={styles.container}>
      <div className={styles.content}>
        <Typography
          variant="text"
          size="xl"
          fontWeight="regular"
          className={styles.subTitle}
        >
          Viewing as: Insurance Agent
        </Typography>
        <Typography
          variant="heading"
          size={isMobile ? 'h5' : 'h4'}
          tag={isMobile ? 'h5' : 'h4'}
        >
          Looking for a Different Industry?
        </Typography>
        <div className={styles.industriesWrapper}>
          {IndustriesData.map((item) => {
            return <IndustryItem key={item.id} item={item} />;
          })}
        </div>
      </div>
    </Section>
  );
};
